module.exports = __webpack_public_path__ + "img/menu.3028ab12.svg";